<template>
<div class="main__wrapper">
  <b-container fluid>
    <b-row :style="cssProps">
      <b-col cols="12">
        <b-form>
          <b-row>
            <b-col v-for="(eachFormObj, eachFormIndex) in forms" class="card mb-4" :key="eachFormIndex" :cols="eachFormObj.span">
              <div class="card-header">
                {{ eachFormObj.title }}
              </div>
              <div class="card-body">
                <b-row :key="`row-${eachFormIndex}`">
                    <b-col :cols="field.span" v-for="(field, index) in eachFormObj.fields" :key="index" :span="field.span" v-bind="field" class="form__group">
                      <b-form-group>
                        <label for="" v-if="field.label && field.fieldType !== 'ModalComponent'">{{ field.label }} {{ field.isRequired ? '*' : '' }}</label>
                        <component :is="field.fieldType"
                        :inRenderMode="true"
                        :currentField="field" class="form__field">
                        </component>
                        <b-form-text style="font-size: 13px; font-style: italic" v-show="field.isHelpBlockVisible" v-text="field.helpBlockText"></b-form-text>
                      </b-form-group>
                    </b-col>
                </b-row>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</div>
</template>

<script>
import {
  FormBuilder
} from '@/components/bs/formbuilder'

export default {
  name: 'Publish',
  store: ['forms', 'themingVars'],
  props: ['standaloneForms'],
  components: FormBuilder.$options.components,
  mounted () {
    if (this.standaloneForms) {
      this.forms = JSON.parse(this.standaloneForms)
    }
  },

  computed: {
    cssProps() {
      // Return an object that will generate css properties key
      // to match with the themingVars
      //
      // Example output: { '--theme-primary-color': this.themingVars.primaryColor }
      var result = {},
        themingVars = this.themingVars;

      for (var v in themingVars) {
        if (themingVars.hasOwnProperty(v)) {
          var newV = "--theme-" + _.kebabCase(v),
            suffix = "";

          // Add px to the value if the default value contain 'px'
          if (_.includes(newV, 'size')) suffix = "px"
          else if (_.includes(newV, 'margin')) suffix = "px"
          else if (_.includes(newV, 'radius')) suffix = "px"

          result[newV] = themingVars[v] + suffix;
        }
      }

      return result;
    }
  }
}
</script>
